import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';
import moment from 'moment';

export default class AgendaAtividadeValidation extends DefaultValidation {

    /* Explicações do funcionamento do validation com MODULOPDA em PropriedadeValidation.js */
    constructor(msgs, modulopda) {
        super(msgs);
        
        if (modulopda && modulopda.detalhe) {
            let detalhe = {};
    
            modulopda.detalhe.forEach(d => {
                detalhe[d.campo] = d;
            });
    
            this.detalhe = detalhe;
            console.log("Iniciando serviço de validação de Agenda Atividade");
        }
    }

    validate(model, id, colaborador, refs) {
        let validated = true;
        let ini = moment(model.datainicio);
        let fim = moment(model.datafim);

        /* Verificando TÍTULO */
        if (this.detalhe.TITULO && this.detalhe.TITULO.obrigainclusao && !this.detalhe.TITULO.oculta) {
            if (!model.titulo) {
                this.showMessage(new Message("error", "msg-atividade-obrigatorio-titulo", true));
                refs.tituloInput.focusedOut = true;
                validated = false;
            }

            if (validated && this.detalhe.TITULO.maxlength && model.titulo && model.titulo.length > this.detalhe.TITULO.maxlength) {
                this.showMessage(new Message("error", "msg-atividade-titulo-maxlength", true));
                refs.tituloInput.focusedOut = true;
                validated = false;
            }
            
            if (validated && this.detalhe.TITULO.validchars) {
                let rgx = this.getRegexValidchars(this.detalhe.TITULO.validchars);
                
                if (!rgx.test(model.titulo.toLocaleLowerCase())) {
                    this.showMessage(new Message("error", "msg-atividade-titulo-invalid-characters", true));
                    refs.tituloInput.focusedOut = true;
                    validated = false;
                }
            }
        }

        /* Colaborador */
        if (
            this.detalhe.USUARIO && this.detalhe.USUARIO.obrigainclusao && !this.detalhe.USUARIO.oculta && 
            (id!=null?model.colaborador==null:colaborador.length==0)
        ) {
            this.showMessage(new Message("error", "msg-atividade-obrigatorio-colaborador", true));
            refs.usuarioSelect.focusedOut = true;
            validated = false;
        }

        /* Tipo de Atividade */
        if (this.detalhe.TIPOAGENDAATIVIDADE && this.detalhe.TIPOAGENDAATIVIDADE.obrigainclusao && !this.detalhe.TIPOAGENDAATIVIDADE.oculta && !model.tipo) {
            this.showMessage(new Message("error", "msg-atividade-obrigatorio-tipo", true));
            refs.tipoAtividadeInput.focusedOut = true;
            validated = false;
        }
        
        /* Cliente */
        if (this.detalhe.CLIENTE && this.detalhe.CLIENTE.obrigainclusao && !this.detalhe.CLIENTE.oculta && !model.cliente) {
            this.showMessage(new Message("error", "msg-atividade-obrigatorio-cliente", true));
            refs.clienteInput.focusedOut = true;
            validated = false;
        }

        /* Propriedade */
        if (this.detalhe.PROPRIEDADE && this.detalhe.PROPRIEDADE.obrigainclusao && this.detalhe.CLIENTE.obrigainclusao && !this.detalhe.CLIENTE.oculta && !this.detalhe.PROPRIEDADE.oculta && (!model.propriedade)) {
            this.showMessage(new Message("error", "msg-atividade-obrigatorio-propriedade", true));
            refs.propriedadeInput.focusedOut = true;
            validated = false;
        }

        /* Data de Início */
        if (this.detalhe.DATAINICIO && this.detalhe.DATAINICIO.obrigainclusao && !this.detalhe.DATAINICIO.oculta && !model.datainicio) {
            this.showMessage(new Message("error", "msg-atividade-obrigatorio-data-inicio", true));
            refs.inicioInput.focusedOut = true;
            validated = false;
        }
        
        /* Data de Fim */
        if (this.detalhe.DATAFIM && this.detalhe.DATAFIM.obrigainclusao && !this.detalhe.DATAFIM.oculta && !model.datafim) {
            this.showMessage(new Message("error", "msg-atividade-obrigatorio-data-fim", true));
            refs.fimInput.focusedOut = true;
            validated = false;
        }

        /* Verifica se a data de início é antes do fim */
        if (model.datainicio && model.datafim && fim.isBefore(ini)) {
            this.showMessage(new Message('error', 'msg-erro-data-inicial-final', true));
            validated = false;
        }

        /* Verificando DESCRIÇÃO */
        if (this.detalhe.DESCRICAO && this.detalhe.DESCRICAO.obrigainclusao && !this.detalhe.DESCRICAO.oculta) {
            if (!model.descricao) {
                this.showMessage(new Message("error", "msg-atividade-obrigatorio-descricao", true));
                refs.descricaoTextArea.focusedOut = true;
                validated = false;
            }

            if (validated && this.detalhe.DESCRICAO.maxlength && model.descricao && model.descricao.length > this.detalhe.DESCRICAO.maxlength) {
                this.showMessage(new Message("error", "msg-atividade-descricao-maxlength", true));
                refs.descricaoTextArea.focusedOut = true;
                validated = false;
            }
            
            if (validated && this.detalhe.DESCRICAO.validchars) {
                let rgx = this.getRegexValidchars(this.detalhe.DESCRICAO.validchars);
                
                if (!rgx.test(model.descricao.toLocaleLowerCase())) {
                    this.showMessage(new Message("error", "msg-atividade-descricao-invalid-characters", true));
                    refs.descricaoTextArea.focusedOut = true;
                    validated = false;
                }
            }
        }
        
        return validated;
    }

}